import { memo } from 'react'
import { FormattedMessage } from 'react-intl'
import { View } from 'react-native'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { H3, Text } from '../../../../elements/typography'
import { formatAward } from '../../formatAward'
import messages from '../../messages'

const ActorAwardsUl = styled(View)`
  padding-left: ${(props) => props.theme.spacing.medium}px;
  width: 92%;
`

const AwardsText = styled(Text)`
  margin-bottom: ${(props) => props.theme.spacing.xsmall}px;
`

const ActorAwards = ({ awards }) => (
  <>
    <H3>
      <FormattedMessage {...messages.awards} />
    </H3>
    <ActorAwardsUl>
      {awards.map((award, i) => (
        <AwardsText key={i}>{formatAward(award)}</AwardsText>
      ))}
    </ActorAwardsUl>
  </>
)

ActorAwards.propTypes = {
  awards: PropTypes.array.isRequired,
}

export default memo(ActorAwards)
